import { DocType, Document } from "models/documents"

import { Agency } from "models/agency"
import { Company } from "models/company"
import { Paginated } from "./types"
import { http } from "./http"

export const fetchCompanies = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.get("companies", { searchParams }).json()
  return res as Paginated<Company>
}

export const fetchCompany = async (
  _key: string,
  id: string,
): Promise<Company> => await http(`companies/${id}`).json()

export const patchCompany = async (pld: Partial<Company>) => {
  const { id, ...data } = pld
  const res = await http.patch(`companies/${id}`, { json: data }).json()
  return res as Company
}

export const fetchUnassignedAgency = async (_key: string, params: string) => {
  const searchParams = new URLSearchParams(params)
  searchParams.set("unassigned", "true")
  const res = await http.get(`agencies`, { searchParams }).json()
  return res as Paginated<Agency>
}

type AddAgencyPayload = {
  id: string
  agencyIds: Array<string>
}

export const AssignedAgencies = async (pld: AddAgencyPayload) => {
  const { id, agencyIds } = pld
  const res = await http
    .post(`companies/${id}/agency-assoc`, { json: { agencyIds } })
    .json()
  return res as Paginated<Agency>
}

type DeleteAgencyCompaniePayload = {
  companyId: string
  agencyId: string
}

export const deleteAgencyCompany = async (pld: DeleteAgencyCompaniePayload) => {
  await http.delete(`companies/${pld.companyId}/agency-assoc/${pld.agencyId}`)
}

export const fetchCompanyDocuments = async (_key: string, id: string) => {
  const res = await http(
    `companies/${id}/documents?sort=DATE_CREATED,DESC`,
  ).json()
  return res as Array<Document>
}

type UploadCompanyCodPld = {
  file?: File
  mediaType?: string
  description?: string
  ownerEntityId: string
  documentType?: DocType
  tags?: string
}

export const uploadCompanyDocument = async (pld: UploadCompanyCodPld) => {
  if (pld.file === undefined) return
  const { file, ownerEntityId, documentType, description } = pld
  const formData = new FormData()
  formData.append("file", file)
  formData.append("name", file.name)
  if (documentType !== undefined) {
    formData.append("documentType", documentType)
  }
  if (description !== undefined) {
    formData.append("description", description)
  }

  const res = await http
    .post(`companies/${ownerEntityId}/documents`, {
      body: formData,
      timeout: false,
    })
    .json()
  return res
}

export const deleteCompanyDocument = async (id: string) => {
  await http.delete(`companies/documents/${id}`)
}

export const activateCompany = async (id: string) =>
  await http.patch(`companies/${id}/activate`)

export const deactivateCompany = async (id: string) =>
  await http.patch(`companies/${id}/deactivate`)

export const fetchCompanyAgencies = async (
  _key: string,
  id?: string,
  params?: string,
) => {
  const searchParams = new URLSearchParams(params)
  const res = await http
    .get(`companies/${id}/agencies`, { searchParams })
    .json()
  return res as Paginated<Company>
}

export const fetchAgencyCompanies = async (
  _key: string,
  params?: string,
  id?: string,
) => {
  const searchParams = new URLSearchParams(params)
  const res = await http
    .get(`agencies/${id}/companies`, { searchParams })
    .json()
  return res as Paginated<Company>
}
